import { useEffect, useState } from "react";
import { Modal, Button, Descriptions, Typography, Spin, Skeleton } from "antd";
import moment from "moment";
import axios from "../../../../utils/axios";
import toast from "react-hot-toast";
import { meterController } from "../../../../controllers/MeterController";
import { errorBlock } from "../../../../controllers/errorBlock";

const { Text } = Typography;

const MeterInfoModal = ({ setopen, open, meterNumber }) => {
  const [meterDetails, setMeterDetails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open) {
      fetchMeterDetails();
    }
  }, [open, meterNumber]);

  const fetchMeterDetails = async () => {
    try {
      setLoading(true);
      let res = await axios.post("/meter/getmeter", {
        meternumber: meterNumber,
      });
      let result = meterController(res);

      if (result.type !== "success") {
        toast[result.type](result.message);
        setLoading(false);
        return;
      }

      setMeterDetails(result.message);
      setLoading(false);
    } catch (err) {
      errorBlock(err);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setopen(false);
  };

  return (
    <Modal
      title="Meter Information"
      open={open}
      onCancel={handleClose}
      width={500}
      footer={[
        <Button
          key="close"
          className="!bg-black !outline-none"
          type="primary"
          onClick={handleClose}
        >
          Done
        </Button>,
      ]}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 8 }} />
      ) : (
        <Descriptions bordered column={1} size="small">
          <Descriptions.Item label="Meter Number">
            <Text strong>{meterDetails?.meterid || "-"}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Meter Type">
            <Text strong>
              {meterDetails?.type || "-"} (
              {meterDetails?.registrar ? "RF" : "SIM"})
            </Text>
          </Descriptions.Item>

          <Descriptions.Item label="Phase Type">
            <Text strong className="capitalize">
              {meterDetails?.phases || "-"}
            </Text>
          </Descriptions.Item>

          <Descriptions.Item label="Meter Registrar">
            <Text strong>{meterDetails?.registrar || "-"}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Meter Model">
            <Text strong>{meterDetails?.model || "-"}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Meter Load Limit (Watts)">
            <Text strong>
              {meterDetails?.loadlimit
                ? meterDetails.loadlimit.toLocaleString("en")
                : "0"}
            </Text>
          </Descriptions.Item>

          <Descriptions.Item label="Date Registered">
            <Text strong>
              {meterDetails?.dateregistered
                ? moment(meterDetails?.dateregistered)
                    .subtract("1", "week")
                    .format("DD-MM-YYYY HH:mm")
                : "-"}
            </Text>
          </Descriptions.Item>

          <Descriptions.Item label="Date Decommissioned">
            <Text strong>
              {meterDetails?.decommissioned
                ? moment(meterDetails?.decommissioned).format(
                    "DD-MM-YYYY HH:mm"
                  )
                : "-"}
            </Text>
          </Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  );
};

export default MeterInfoModal;
